export const nav = (initialIsNavToggled = false) => {
  const body = document.body;
  const header = document.querySelector(".js-header");
  const mobileNav = document.querySelector(".js-mobile-nav");
  const btnToggleNav = document.querySelectorAll(".js-toggle-mobile-nav");
  const navElement = document.querySelector(".js-nav");
  const navLinks = document.querySelectorAll('.c-nav-mobile__list a');
  const topObservers = document.querySelectorAll('.js-observe-top');
  const bottomObservers = document.querySelectorAll('.js-observe-bottom');

  let brMed = 968;
  let isNavToggled = initialIsNavToggled;
  let originalTopColors = new Map();
  let originalBottomColors = new Map();

  const observer = new IntersectionObserver(
    ([e]) => e.target.toggleAttribute("stuck", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  const toggle = () => {
    if (isNavToggled) {
      mobileNav?.setAttribute("aria-hidden", "true");
      body.setAttribute("data-menu-open", "false");
      body.classList.remove("no-scroll");
      // Restore original text colors
      topObservers.forEach(observer => {
        const originalColor = originalTopColors.get(observer);
        if (originalColor) {
          observer.setAttribute("data-text-color", originalColor);
        }
      });
      bottomObservers.forEach(observer => {
        const originalColor = originalBottomColors.get(observer);
        if (originalColor) {
          observer.setAttribute("data-text-color", originalColor);
        }
      });
      originalTopColors.clear();
      originalBottomColors.clear();
    } else {
      mobileNav?.setAttribute("aria-hidden", "false"); 
      body.setAttribute("data-menu-open", "true");
      body.classList.add("no-scroll");
      // Save and change text colors
      topObservers.forEach(observer => {
        originalTopColors.set(observer, observer.getAttribute("data-text-color"));
        observer.setAttribute("data-text-color", "light");
      });
      bottomObservers.forEach(observer => {
        originalBottomColors.set(observer, observer.getAttribute("data-text-color"));
        observer.setAttribute("data-text-color", "light");
      });
    }

    isNavToggled = !isNavToggled;
    return isNavToggled;
  };

  const bind = () => {
    btnToggleNav.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        toggle();
      });
    });

    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        if (isNavToggled) {
          toggle();
        }
      });
    });

    if (navElement) {
      observer.observe(navElement);
    }
  };

  window.addEventListener("resize", () => {
    if (window.innerWidth > brMed && isNavToggled) {
      toggle();
    }
  });

  bind();

  return {
    isNavToggled,
    toggle
  };
};
